import S from 's-js';
import { Errors } from './validationWatcher';

/**
 * A utility class for doing client-side validation. This exposes errors in the same format as
 * our ValidationWatcher utility for displaying server-side validation errors. The intention is
 * that viewmodel code can switch btwn server-side and client-side validation (or a combo of the
 * two) w/o changing the API it exposes to view code.
 */
export class ValidationRules {
    validation : () => Errors;

    constructor(...rules : ValidationRule[]) {
        this.validation = S(() => {
            const errorSink = {} as ErrorSink;
            for (let rule of rules) {
                rule.run(errorSink);
            }
            const errors = {} as Errors;
            for (let key in errorSink) {
                const theseErrors = errorSink[key];
                if (theseErrors && theseErrors.length > 0) {
                    errors[key] = {
                        Field: key,
                        RawErrors: theseErrors,
                        ErrorTexts: theseErrors,
                        ErrorText: theseErrors[0]
                    };
                }
            }
            return errors;
        });
    }
}

export class ValidationRule {
    constructor(
        readonly field : string,
        readonly isValid : () => boolean,
        readonly errorText : string | (() => string)
    ) { }

    run(errorSink : ErrorSink) {
        const errors = errorSink[this.field] = errorSink[this.field] || [];
        if (!this.isValid()) errors.push(this.getErrorText());
    }

    private getErrorText() {
        return typeof this.errorText === 'string' ? this.errorText : this.errorText();
    }
}

interface ErrorSink {
    [field : string] : string[] | undefined;
}



// WEBPACK FOOTER //
// ./lib/clientSideValidation.ts